var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('product_create')) + " ")]), _c('v-stepper', {
    staticClass: "creation-stepper",
    attrs: {
      "flat": ""
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1,
      "color": _vm.step > 1 ? 'grey' : 'primary'
    }
  }, [_vm._v(" " + _vm._s(_vm.step > 1 ? _vm.$t('product_created') : _vm.$t('product_create')) + " ")]), _c('v-divider'), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2,
      "color": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('set_up_page_after_scan')) + " ")])], 1), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('div', {
    staticClass: "step-body d-flex flex-column flex-md-row"
  }, [_c('div', {
    staticClass: "image-ctn mr-md-6 mb-4 mb-md-0"
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.productImage
    }
  }), _c('image-cropper', {
    attrs: {
      "input-key": "product-creation-image",
      "gallery-only": true,
      "show-select-dialog": true
    },
    on: {
      "image-selected": _vm.onImageSelect
    }
  })], 1), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('v-form', {
    ref: "product-form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    staticClass: "field-row",
    attrs: {
      "outlined": "",
      "dense": "",
      "persistent-hint": "",
      "validate-on-blur": "",
      "name": "name",
      "label": `${_vm.$t('product_name')}*`,
      "hint": _vm.$t('product_name_hint'),
      "rules": _vm.rules.name,
      "error-messages": _vm.errorMessages.name,
      "required": ""
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('name');
      }
    },
    model: {
      value: _vm.productForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "name", $$v);
      },
      expression: "productForm.name"
    }
  }), _c('v-text-field', {
    staticClass: "field-row",
    attrs: {
      "outlined": "",
      "dense": "",
      "persistent-hint": "",
      "validate-on-blur": "",
      "name": "gtin",
      "counter": 14,
      "label": _vm.$t('gtin'),
      "hint": _vm.$t('product_gtin_hint'),
      "rules": _vm.gtinRules,
      "error-messages": _vm.errorMessages.gtin
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('gtin');
      }
    },
    model: {
      value: _vm.productForm.gtin,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "gtin", $$v);
      },
      expression: "productForm.gtin"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "persistent-hint": "",
      "name": "sku",
      "label": _vm.$t('product_internal_name'),
      "hint": _vm.$t('product_sku_hint'),
      "rules": _vm.rules.sku,
      "error-messages": _vm.errorMessages.sku
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('sku');
      }
    },
    model: {
      value: _vm.productForm.sku,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "sku", $$v);
      },
      expression: "productForm.sku"
    }
  })], 1), _c('div', {
    staticClass: "inline-hint mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-lightbulb-outline")]), _c('span', [_vm._v(_vm._s(_vm.$t('product_details_update_later_hint')))])], 1)], 1)]), _c('v-card-actions', {
    staticClass: "step-actions"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.savingProduct
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "raised": "",
      "color": "primary",
      "loading": _vm.savingProduct,
      "disabled": !_vm.productForm.name || _vm.savingProduct
    },
    on: {
      "click": function ($event) {
        return _vm.handleNext();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "step-title"
  }, [_vm._v(_vm._s(_vm.$t('scan_destination_title')))]), _c('div', {
    staticClass: "step-hint"
  }, [_vm._v(_vm._s(_vm.$t('scan_destination_hint')))]), _c('destination-cards', {
    staticClass: "mt-6",
    attrs: {
      "orientation": "vertical",
      "value": _vm.destinationType
    },
    on: {
      "input": _vm.onDestinationSelect
    }
  }), _vm.destinationType === 'existing' ? _c('div', [_c('v-divider', {
    staticClass: "my-5"
  }), _c('v-autocomplete', {
    ref: "existingSelect",
    attrs: {
      "items": _vm.existingLandingPages,
      "loading": _vm.landingPagesLoading,
      "search-input": _vm.landingPageSearch,
      "no-filter": true,
      "label": _vm.$t('select_landing_page'),
      "no-data-text": _vm.$t('no_data_available'),
      "menu-props": {
        offsetY: true
      },
      "rules": _vm.rules.stc_config,
      "item-value": "id",
      "item-text": "name",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.landingPageSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.landingPageSearch = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex align-center",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('span', {
          staticClass: "flex-grow-1 text-truncate"
        }, [_vm._v(_vm._s(item.name))]), _c('span', {
          staticClass: "page-tag"
        }, [_vm._v(_vm._s(_vm.landingPageLayoutTag(item)))])])];
      }
    }, {
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(_vm.landingPageLayoutTag(item)))])];
      }
    }], null, false, 1947372199),
    model: {
      value: _vm.form.stc_config,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stc_config", $$v);
      },
      expression: "form.stc_config"
    }
  })], 1) : _vm._e(), _vm.destinationType === 'redirect' ? _c('div', [_c('v-divider', {
    staticClass: "my-5"
  }), _c('v-form', {
    ref: "urlForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('url'),
      "rules": _vm.urlRules,
      "placeholder": "https://www.example.com",
      "validate-on-blur": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.url,
      callback: function ($$v) {
        _vm.$set(_vm.form, "url", $$v);
      },
      expression: "form.url"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "step-actions"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.savingDestination
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "raised": "",
      "color": "primary",
      "loading": _vm.savingDestination
    },
    on: {
      "click": function ($event) {
        return _vm.handleSaveDestination();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('div', {
    staticClass: "step-body success-body"
  }, [_c('v-icon', {
    attrs: {
      "size": "60",
      "color": "#3fc135"
    }
  }, [_vm._v("mdi-check-circle-outline")]), _c('div', {
    staticClass: "success-title mt-4"
  }, [_vm._v(_vm._s(_vm.successTitle))]), _c('div', {
    staticClass: "success-text mt-1"
  }, [_vm._v(_vm._s(_vm.successText))]), _c('div', {
    staticClass: "inline-hint justify-center mt-6"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-lightbulb-outline")]), _c('span', [_vm._v(_vm._s(_vm.$t('change_destination_anytime_hint')))])], 1)], 1), _c('v-card-actions', {
    staticClass: "step-actions"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _vm.destinationType === 'dpp' ? _c('v-btn', {
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openDppEditor();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('add_product_data')))]) : _vm.destinationType === 'custom' ? _c('v-btn', {
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openLandingPageEditor();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('open_editor')))]) : _vm._e()], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }